import PropTypes from 'prop-types';
// -*- mode: jsx;-*-

export const AjaxLink = ({ href, className, children, handleLink }) => {
    const onClick = (event) => {
        handleLink(href);
        event.preventDefault();
    };

    return (
        <a href={href} onClick={onClick} className={className}>
            {children}
        </a>
    );
};

AjaxLink.propTypes = {
    handleLink: PropTypes.func.isRequired,
    children: PropTypes.any.isRequired,
    href: PropTypes.string,

    className: PropTypes.string,
};
